import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";
import { shallowEqual } from "../../../utils/shallowEqual";

/**
 * Atom that selects question groups from the questionnaire state.
 *
 * This atom uses shallow equality comparison to only trigger re-renders
 * when the groups object actually changes (not just when a new reference
 * is created with the same contents).
 */
export const questionnaireGroupsAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.groups,
  shallowEqual,
);
